export const PENSION_TYPES_MAP = {
  Benefit: 'Defined Benefit',
  Contribution: 'Defined Contribution'
};

export const DIFFICULTIES_MAPPERS_CONFIG = {
  SERVICE_SEPARATOR: '-',
  MATCH_LOWER_SERVICE: 'Less than',
  MATCH_UPPER_SERVICE: '+',
  PERIOD_SEPARATOR: '-',
  MATCH_LOWER_PERIOD: 'Before',
  MATCH_UPPER_PERIOD: 'onwards'
};

export const PENSION_DIFFICULTIES = { LOW: 'easy', MEDIUM: 'challenging', HIGH: 'hard', FOUND: 'found' };
export const PENSION_COMPANY_SIZES = ['SMALL', 'MEDIUM', 'LARGE'];
